export const FORM_TEMPLATE_QUESTION_INSIGHT_SOURCE_VALUES = ['HISTORICAL', 'CONFIG'] as const
export type FormTemplateQuestionInsightSource = (typeof FORM_TEMPLATE_QUESTION_INSIGHT_SOURCE_VALUES)[number]

export const QUESTION_INSIGHT_GENERATION_STATUS_VALUES = ['IN_PROGRESS', 'COMPLETE', 'FAILED'] as const
export type QuestionInsightGenerationStatus = (typeof QUESTION_INSIGHT_GENERATION_STATUS_VALUES)[number]

export enum FormTemplateStateEnum {
  ARCHIVED = 'ARCHIVED',
  DRAFT = 'DRAFT',
  PUBLISHED = 'PUBLISHED',
}
export enum FormTypeEnum {
  ACCESS_REQUEST = 'ACCESS_REQUEST',
  CANCEL_AGREEMENT = 'CANCEL_AGREEMENT',
  CANCEL_ASSESSMENTS = 'CANCEL_ASSESSMENTS',
  CATALOGUE_PURCHASE = 'CATALOGUE_PURCHASE',
  /** Details to commit to the supplier  */
  COMMIT_SUPPLIER_DATA = 'COMMIT_SUPPLIER_DATA',
  /** Hidden two-question template backing a content generation task */
  CONTENT_GENERATION = 'CONTENT_GENERATION',
  CREATE_AGREEMENT = 'CREATE_AGREEMENT',
  CREATE_ASSESSMENT = 'CREATE_ASSESSMENT',
  CREATE_ENGAGEMENT = 'CREATE_ENGAGEMENT',
  CREATE_PURCHASE_ORDER = 'CREATE_PURCHASE_ORDER',
  /** Used as a base to create a renewal. Currently a hard coded form we clone when the task needs to be created. */
  CREATE_RENEWAL = 'CREATE_RENEWAL',
  /** External operation output forms */
  EXTERNAL_OPERATION = 'EXTERNAL_OPERATION',
  INTAKE = 'INTAKE',
  OTHER = 'OTHER',
  RENEWAL_ASSESSMENT = 'RENEWAL_ASSESSMENT',
  RFX = 'RFX',
  SUPPLIER_ONBOARDING = 'SUPPLIER_ONBOARDING',
}
